import {
  Route,
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
} from "react-router-dom";
import { Terms } from "containers/Terms";
import { Privacy } from "containers/Privacy";
import { AqroKredit } from "containers/AqroKredit";
import App from 'App'

const RouterComponent = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<App />} />
        <Route path="/intro/terms" element={<Terms />} />
        <Route path="/intro/privacy-policy" element={<Privacy />} />
        <Route path="/aqrokredit/:phone" element={<AqroKredit />} />
        <Route path="*" element={<App />} />
      </Route>
    )
  );

  return <RouterProvider router={router} />;
};

export default RouterComponent;
